import React from 'react';
import { useSelector } from 'react-redux';

import BasicEmptyListing from 'src/components/EmptyListing/BasicEmptyListing';
import ActionLink from 'src/components/EmptyListing/ActionLink';


const AgreementMissing = function () {
  const settingsURL = useSelector(
    ({ configReducer }) => configReducer.settingsURL
  );
  const agreementMissingImage = useSelector(
    ({ imagesReducer }) => imagesReducer.agreementMissing
  );

  return (
    <BasicEmptyListing
      copy={ (
        <ActionLink
          dataTest="anchor-profilingAgreement"
          href={ settingsURL }
          label="Włącz zgodę"
        />
      ) }
      header="Brak zgody na profilowanie"
      hint="Włącz zgodę w ustawieniach aby zobaczyć oferty pracy dopasowane do Ciebie"
      imageSource={ agreementMissingImage }
    />
  );
};

export default AgreementMissing;
